import type { LocaleObject } from '@nuxtjs/i18n';

export interface AvailableLocale extends LocaleObject {
    icuCode: string;
}

const availableLocales = [
    {
        code: 'en',
        name: 'English',
        language: 'en',
        file: 'en.ts',
        icon: 'en-flag',
        icuCode: 'en_US',
    },
    {
        code: 'pl',
        name: 'Polski',
        language: 'pl',
        file: 'pl.ts',
        icon: 'pl-flag',
        icuCode: 'pl_PL',
    },
    {
        code: 'de',
        name: 'Deutsch',
        language: 'de',
        file: 'de.ts',
        icon: 'de-flag',
        icuCode: 'de_DE',
    },
    {
        code: 'ru',
        name: 'Русский',
        language: 'ru',
        file: 'ru.ts',
        icon: 'ru-flag',
        icuCode: 'ru_RU',
    },
    {
        code: 'es',
        name: 'Español',
        language: 'es',
        file: 'es.ts',
        icon: 'es-flag',
        icuCode: 'es_ES',
    },
    {
        code: 'fr',
        name: 'Français',
        language: 'fr',
        file: 'fr.ts',
        icon: 'fr-flag',
        icuCode: 'fr_FR',
    },
    {
        code: 'it',
        name: 'Italiano',
        language: 'it',
        file: 'it.ts',
        icon: 'it-flag',
        icuCode: 'it_IT',
    },
    {
        code: 'br',
        name: 'Português (Brasil)',
        language: 'pt-BR',
        file: 'br.ts',
        icon: 'br-flag',
        icuCode: 'pt_BR',
    },
] as const satisfies Readonly<AvailableLocale[]>;

export type AvailableLocalesCode = (typeof availableLocales)[number]['code'];

export default availableLocales;
